import { relativePaths } from '@app/constants';
import { PremiumCoverageModalComponent } from '@app/modules/waterways/shared/premium-coverage-modal/premium-coverage-modal.component';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { LocationService } from '@app/core/services/location/location.service';

@Component({
  selector: 'app-sign-up',
  templateUrl: './sign-up.component.html',
  styleUrls: ['./sign-up.component.scss'],
})
export class SignUpComponent implements OnInit {
  public userLogin = true;

  constructor(
    private dialog: MatDialog,
    private locationService: LocationService,
  ) { }

  ngOnInit() {
  }

  public navigateWaterway() {
    const { dialog } = this;
    dialog.open(PremiumCoverageModalComponent, {
    });
  }

  public navigateSignupFree() {
    this.locationService.replace(relativePaths.SIGN_UP + relativePaths.SIGN_UP_FREE);
  }

  public navigateSignupPremium() {
    this.locationService.replace(relativePaths.SIGN_UP_PREMIUM);
  }
}
